module.exports = __webpack_public_path__ + "img/info5.51d3d1a9.png";